// eslint-disable-next-line import/prefer-default-export
export enum Colors {
  RED = '#f32450',
  CYAN = '#8dd3c7',
  YELLOW = '#ffff00',
  PURPLE = '#bebada',
  GREEN = '#77de3c',
  BLUE = '#2fe3ff',
  GREY = '#334455',

  // dark theme - keep this in sync with: src/themes/dark.less and common.less
  ACCENT = '#2F49D1',
  TEXT = '#CECECE',
  MAIN = '#1E1E1E',
  MAIN_DARK = '#191C1E',
  MAIN_LIGHT = '#252525',
}
